<template>
  <div class="d-flex">
    <div class="d-flex flex-fill" v-for="series in eventsData.series" :key="series.name">
      <div class="card m-1" style="width: 100%">
        <events-attendance-chart v-bind:series-data="series" v-bind:background="'#243447'"/>
      </div>
    </div>
  </div>
</template>

<script>
import EventsAttendanceChart from './EventsAttendanceChart'
export default {
  name: '',
  props: ['eventsData'],
  components: {
    EventsAttendanceChart
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/events/EventDashboard.vue